import React from "react";
import "@/App.css";
import Landing from "@/pages/Landing";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App grain">
      <Landing />
      <Toaster
        position="bottom-right"
        theme="light"
        toastOptions={{
          style: {
            background: "#F7F4ED",
            color: "#1A2820",
            border: "1px solid rgba(156, 126, 31, 0.35)",
            borderRadius: 0,
            fontFamily: "Outfit, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
